// AJAX Cart Functionality - More Robust Version
(function() {
  'use strict';

  class AjaxCart {
    constructor() {
      this.notification = document.querySelector('cart-notification');
      this.notificationElement = document.getElementById('cart-notification');
      this.notificationProduct = document.getElementById('cart-notification-product');
      this.notificationButton = document.getElementById('cart-notification-button');
      
      this.init();
    }
    
    init() {
      // Use event delegation to catch all form submissions
      document.addEventListener('submit', (e) => {
        // Check if it's a cart add form
        if (e.target.matches('.spf-product__form') || 
            e.target.matches('form[action*="/cart/add"]')) {
          e.preventDefault();
          e.stopPropagation();
          this.addToCart(e.target);
        }
      }, true); // Use capture phase
      
      // Close notification buttons
      if (this.notification) {
        const closeButton = this.notification.querySelector('.cart-notification__close');
        const continueButton = this.notification.querySelector('.link.button-label');
        
        if (closeButton) {
          closeButton.addEventListener('click', () => this.hideNotification());
        }
        
        if (continueButton) {
          continueButton.addEventListener('click', () => this.hideNotification());
        }
      }
      
      console.log('AJAX Cart initialized');
    }
    
    async addToCart(form) {
      console.log('Adding to cart...', form);
      
      const submitButton = form.querySelector('[type="submit"]');
      const buttonSpan = submitButton.querySelector('span');
      const originalButtonText = buttonSpan ? buttonSpan.textContent : submitButton.textContent;
      
      // Disable button and show loading state
      submitButton.disabled = true;
      if (buttonSpan) {
        buttonSpan.textContent = 'Adding...';
      } else {
        submitButton.textContent = 'Adding...';
      }
      
      // Get form data
      const formData = new FormData(form);
      
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        });
        
        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.description || 'Failed to add to cart');
        }
        
        const item = await response.json();
        console.log('Item added:', item);
        
        // Show notification with product details
        await this.showNotification(item);
        
        // Update cart count
        await this.updateCartCount();
        
        // Re-enable button
        submitButton.disabled = false;
        if (buttonSpan) {
          buttonSpan.textContent = originalButtonText;
        } else {
          submitButton.textContent = originalButtonText;
        }
        
      } catch (error) {
        console.error('Error adding to cart:', error);
        alert(error.message || 'There was an error adding the item to your cart. Please try again.');
        
        // Re-enable button
        submitButton.disabled = false;
        if (buttonSpan) {
          buttonSpan.textContent = originalButtonText;
        } else {
          submitButton.textContent = originalButtonText;
        }
      }
    }
    
    async showNotification(item) {
      if (!this.notification || !this.notificationElement) {
        console.warn('Cart notification element not found');
        return;
      }
      
      // Populate notification with product details
      this.notificationProduct.innerHTML = this.renderCartItem(item);
      
      // Update the view cart button with cart count
      const cart = await this.getCart();
      this.notificationButton.textContent = `View my cart (${cart.item_count})`;
      
      // Show the notification
      this.notificationElement.style.display = 'block';
      
      // Animate in
      setTimeout(() => {
        this.notificationElement.classList.add('animate', 'active');
      }, 10);
      
      // Auto-hide after 5 seconds
      setTimeout(() => {
        this.hideNotification();
      }, 5000);
    }
    
    hideNotification() {
      if (!this.notificationElement) return;
      
      this.notificationElement.classList.remove('active');
      
      setTimeout(() => {
        this.notificationElement.style.display = 'none';
        this.notificationElement.classList.remove('animate');
      }, 300);
    }
    
    renderCartItem(item) {
      const price = this.formatMoney(item.price);
      const linePrice = this.formatMoney(item.line_price);
      
      return `
        <div class="cart-notification-product__info">
          <div class="cart-notification-product__image">
            ${item.image ? `<img src="${item.image}" alt="${item.product_title}" loading="lazy">` : ''}
          </div>
          <div class="cart-notification-product__details">
            <h3 class="cart-notification-product__name h4">${item.product_title}</h3>
            ${item.variant_title ? `<div class="cart-notification-product__variant">${item.variant_title}</div>` : ''}
            <div class="cart-notification-product__price">
              <span class="price">${price}</span>
              ${item.quantity > 1 ? `<span class="quantity"> × ${item.quantity} = ${linePrice}</span>` : ''}
            </div>
          </div>
        </div>
      `;
    }
    
    async getCart() {
      try {
        const response = await fetch('/cart.js');
        return await response.json();
      } catch (error) {
        console.error('Error fetching cart:', error);
        return { item_count: 0 };
      }
    }
    
    async updateCartCount() {
      const cart = await this.getCart();
      
      // Update all cart count elements
      const cartCountElements = document.querySelectorAll('.cart-count, [data-cart-count], .count-bubble');
      cartCountElements.forEach(element => {
        element.textContent = cart.item_count;
        if (cart.item_count > 0) {
          element.style.display = '';
        }
      });
      
      // Dispatch custom event for other scripts
      document.dispatchEvent(new CustomEvent('cart:updated', { 
        detail: { cart } 
      }));
    }
    
    formatMoney(cents) {
      // Format money in cents to Rands
      const amount = (cents / 100).toFixed(2);
      return `R${amount}`;
    }
  }

  // Initialize immediately when script runs
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.ajaxCart = new AjaxCart();
    });
  } else {
    window.ajaxCart = new AjaxCart();
  }

})();